<template>
  <b-modal
      :visible="visible"
      size="lg"
      title="بررسی گروهی درخواست ها"
      hide-footer
      :no-close-on-backdrop="sending"
      :no-close-on-esc="sending"
      :hide-header-close="sending"
      @change="onVisibleChange"
      @hidden="reset"
  >
    <template v-if="!bulkReview">
      <b-alert
          show
          variant="primary"
          class="p-1"
      >
        <span v-if="scope.mode === 'filter'">
          پاسخ شما برای همه‌ی {{ count }} درخواست مطابق فیلترها ثبت می‌شود.
        </span>
        <span v-else>
          پاسخ شما برای {{ count }} درخواست انتخاب شده ثبت می‌شود.
        </span>
      </b-alert>

      <b-form @submit.prevent>
        <b-form-group label="توضیحات">
          <quill-editor
              v-model="content"
              :options="editorOption"
              style="min-height:150px;"
          />
        </b-form-group>

        <b-row
            v-for="(item, index) in attachment.items"
            :key="item.id"
        >
          <b-col md="9">
            <b-form-group>
              <label :for="`bulk_attachment_${item.id}`">
                <feather-icon icon="PaperclipIcon" />
                فایل
              </label>
              <b-form-file
                  :id="`bulk_attachment_${item.id}`"
                  v-model="item.file"
                  placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                  no-drop
                  :disabled="sending"
              />
            </b-form-group>
          </b-col>
          <b-col
              md="3"
              class="mb-50"
          >
            <b-button
                variant="outline-danger"
                class="mt-0 mt-md-2"
                :disabled="sending"
                @click="removeItem(index)"
            >
              <feather-icon
                  icon="XIcon"
                  class="mr-25"
              />
              <span>حذف فایل</span>
            </b-button>
          </b-col>
        </b-row>
        <b-button
            variant="primary"
            size="sm"
            :disabled="sending"
            @click="addItem"
        >
          <feather-icon
              icon="PlusIcon"
              class="mr-25"
          />
          <span>افزودن فایل</span>
        </b-button>
      </b-form>

      <hr>
      <div class="d-flex flex-wrap justify-content-end">
        <b-button
            variant="outline-danger"
            size="sm"
            class="ml-1 mb-50"
            :disabled="sending"
            @click="answer('reject')"
        >
          رد درخواست
        </b-button>
        <b-button
            variant="outline-primary"
            size="sm"
            class="ml-1 mb-50"
            :disabled="sending"
            @click="answer('review')"
        >
          نیاز به بازنگری
        </b-button>
        <b-button
            variant="success"
            size="sm"
            class="ml-1 mb-50"
            :disabled="sending"
            @click="answer('accept')"
        >
          <b-spinner
              v-if="sending"
              small
              class="mr-25"
          />
          تأیید درخواست
        </b-button>
      </div>
    </template>

    <template v-else>
      <p class="mb-50">
        <span v-if="finished">بررسی گروهی تمام شد.</span>
        <span v-else>در حال ثبت پاسخ‌ها... می‌توانید این پنجره را ببندید؛ کار در پس‌زمینه ادامه پیدا می‌کند.</span>
      </p>
      <b-progress
          :max="bulkReview.total"
          height="1.25rem"
          class="mb-50"
      >
        <b-progress-bar
            :value="bulkReview.succeeded"
            variant="success"
        />
        <b-progress-bar
            :value="bulkReview.failed"
            variant="danger"
        />
      </b-progress>
      <p>
        {{ bulkReview.succeeded + bulkReview.failed }} از {{ bulkReview.total }} درخواست؛
        <span class="text-success">{{ bulkReview.succeeded }} موفق</span>
        <span
            v-if="bulkReview.failed > 0"
            class="text-danger"
        >، {{ bulkReview.failed }} ناموفق</span>
      </p>

      <div v-if="bulkReview.failures.length > 0">
        <h6>درخواست‌هایی که پاسخ داده نشد</h6>
        <b-list-group class="mb-1">
          <b-list-group-item
              v-for="failure in bulkReview.failures"
              :key="failure.request_id"
              class="d-flex flex-wrap justify-content-between"
          >
            <b-link
                :to="{name: 'Requests_Detail', params: {id: failure.request_id}}"
                target="_blank"
            >
              {{ failure.request_id }} - {{ failure.title }}
            </b-link>
            <small class="text-danger">{{ failure.error }}</small>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div class="d-flex justify-content-end">
        <b-button
            variant="primary"
            size="sm"
            @click="$emit('change', false)"
        >
          بستن
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BAlert,
  BButton,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BProgress,
  BProgressBar,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {quillEditor} from 'vue-quill-editor'
import {DEFAULT_ANSWER_HTML, answerTextFor} from './answerText'

/** How often the progress is asked for, in milliseconds. */
const POLL_INTERVAL = 2000

/** Filters the backend reads as lists. */
const LIST_FILTERS = ['roles', 'permissions', 'finisherRoles', 'finisherPermissions', 'finisherUsers']

const ANSWER_TITLES = {
  accept: 'تأیید',
  review: 'نیاز به بازنگری',
  reject: 'رد',
}

function newAttachments() {
  return {
    items: [{id: 1, file: null}],
    nextItemId: 2,
  }
}

/**
 * One answer — تأیید، نیاز به بازنگری یا رد — with a text and files for many
 * requests of the inbox: the ones picked, or every one the filters match.
 * The backend answers them in the background; this shows how far it got and
 * which requests could not be answered.
 */
export default {
  name: 'BulkReviewModal',
  components: {
    BAlert,
    BButton,
    BCol,
    BForm,
    BFormFile,
    BFormGroup,
    BLink,
    BListGroup,
    BListGroupItem,
    BModal,
    BProgress,
    BProgressBar,
    BRow,
    BSpinner,
    quillEditor,
  },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /**
     * `{mode: 'ids', ids: [...]}` or `{mode: 'filter', filters: {...}}`, the
     * filters as the inbox list sends them.
     */
    scope: {
      type: Object,
      required: true,
    },
    /** How many requests the answer is for, as the user sees it. */
    count: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      content: DEFAULT_ANSWER_HTML,
      attachment: newAttachments(),
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{direction: 'rtl'}],
            [{color: []}, {background: []}],
            [{align: []}],
            ['clean'],
          ],
        },
        theme: 'snow',
        placeholder: 'متن پاسخ را وارد کنید',
      },
      sending: false,
      bulkReview: null,
      pollTimer: null,
    }
  },
  computed: {
    finished() {
      return this.bulkReview && this.bulkReview.status === 'done'
    },
    toaster() {
      return `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`
    },
  },
  beforeDestroy() {
    clearTimeout(this.pollTimer)
  },
  methods: {
    addItem() {
      this.attachment.items.push({id: this.attachment.nextItemId, file: null})
      this.attachment.nextItemId++
    },
    removeItem(index) {
      this.attachment.items.splice(index, 1)
    },
    onVisibleChange(visible) {
      if (!visible && this.bulkReview && !this.finished) {
        this.$bvToast.toast('ثبت پاسخ‌ها در پس‌زمینه ادامه دارد.', {
          title: 'بررسی گروهی',
          toaster: this.toaster,
          variant: 'info',
        })
      }
      this.$emit('change', visible)
    },
    /** Once closed: a bulk review that was sent changed the inbox. */
    reset() {
      clearTimeout(this.pollTimer)
      if (this.bulkReview) {
        this.$emit('done')
      }
      this.content = DEFAULT_ANSWER_HTML
      this.attachment = newAttachments()
      this.sending = false
      this.bulkReview = null
    },
    /** The text without its markup, e.g. nothing for an emptied editor. */
    hasText() {
      const {body} = new DOMParser().parseFromString(this.content, 'text/html')
      return body.textContent.trim() !== ''
    },
    async answer(action) {
      if (!this.hasText()) {
        this.$bvToast.toast('متن پاسخ نمی تواند خالی باشد', {
          title: 'خطا',
          toaster: this.toaster,
          variant: 'danger',
        })
        return
      }

      const content = await answerTextFor(this.$swal, this.content, action)
      if (content === null) {
        return
      }
      this.content = content

      this.confirm(action, this.count)
    },
    confirm(action, count, text = null) {
      this.$swal({
        title: `${ANSWER_TITLES[action]} ${count} درخواست؟`,
        text: text ?? (action === 'reject'
          ? 'رد کردن این درخواست‌ها را تمام می‌کند و به درخواست‌دهنده‌ها خبر داده می‌شود.'
          : 'این پاسخ برای همه‌ی درخواست‌ها ثبت می‌شود و برگرداندن آن ممکن نیست.'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'بله، مطمئنم',
        cancelButtonText: 'منصرف شدم',
        customClass: {
          confirmButton: action === 'reject' ? 'btn btn-danger' : 'btn btn-primary',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
              this.send(action, count)
            }
          })
    },
    formData(action, count) {
      const data = new FormData()
      data.append('action', action)
      data.append('content', this.content)
      data.append('mode', this.scope.mode)
      this.attachment.items
          .filter(item => item.file)
          .forEach(item => data.append('attachments[]', item.file))

      if (this.scope.mode === 'ids') {
        this.scope.ids.forEach(id => data.append('ids[]', id))
        return data
      }

      data.append('expected_total', count)
      Object.entries(this.scope.filters).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') return

        if (LIST_FILTERS.includes(key)) {
          [].concat(value)
              /** The finisher user select keeps the whole user. */
              .map(item => (item && typeof item === 'object' ? item.id : item))
              .forEach(item => data.append(`filters[${key}][]`, item))
        } else {
          data.append(`filters[${key}]`, value)
        }
      })
      return data
    },
    send(action, count) {
      this.sending = true
      this.$http.post('requests/bulk-reviews', this.formData(action, count))
          .then(({data}) => {
            this.bulkReview = data.bulkReview
            this.poll()
          })
          .catch(error => {
            const response = error.response ?? {}
            /** The filters match another number of requests by now. */
            if (response.status === 409 && response.data && response.data.total !== undefined) {
              this.confirm(action, response.data.total, response.data.message)
              return
            }
            this.$bvToast.toast(this.errorOf(response), {
              title: 'خطا',
              toaster: this.toaster,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.sending = false
          })
    },
    errorOf(response) {
      const data = response.data ?? {}
      if (data.errors) {
        return Object.values(data.errors).flat()[0]
      }
      return data.message ?? 'ثبت پاسخ‌ها انجام نشد'
    },
    poll() {
      if (this.finished) {
        this.onFinished()
        return
      }
      this.pollTimer = setTimeout(() => {
        this.$http.get(`requests/bulk-reviews/${this.bulkReview.id}`)
            .then(({data}) => {
              if (this.bulkReview && data.status) {
                this.bulkReview = data.bulkReview
              }
            })
            .catch(() => {})
            .finally(() => {
              if (this.bulkReview) {
                this.poll()
              }
            })
      }, POLL_INTERVAL)
    },
    onFinished() {
      const {succeeded, failed} = this.bulkReview
      this.$bvToast.toast(
          failed > 0
            ? `${succeeded} درخواست پاسخ داده شد و ${failed} درخواست ناموفق بود.`
            : `${succeeded} درخواست پاسخ داده شد.`,
          {
            title: 'بررسی گروهی',
            toaster: this.toaster,
            variant: failed > 0 ? 'warning' : 'success',
          },
      )
    },
  },
}
</script>
